import { render, staticRenderFns } from "./AboutProductsOriginal.vue?vue&type=template&id=0bb4f0a8&scoped=true&"
import script from "./AboutProductsOriginal.vue?vue&type=script&lang=js&"
export * from "./AboutProductsOriginal.vue?vue&type=script&lang=js&"
import style0 from "./AboutProductsOriginal.vue?vue&type=style&index=0&id=0bb4f0a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb4f0a8",
  null
  
)

export default component.exports